<template>                
    <a class="button is-block" v-bind:class="[color, {'is-loading' : loading}]" @click="click($event)">
        <span class="icon" v-if="icon != ''">
            <i v-bind:class="['fa', icon]"></i>
        </span>
        <slot></slot>
    </a>
</template>

<script>

export default {
    name: 'loading-button',
    props: {
    	loading: { required: true },
	color: {required: false, default: 'is-info'},
        icon: {required: false, default: ''}
    },
    data () {
	return {
	};    
    },
    methods: {
	click($event) {            
	    this.$emit('click', $event); 	    
	},
    },    
    mounted () {  
	
    },
    
    destroyed() {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>



</style>



// WEBPACK FOOTER //
// src/components/util/LoadingButton.vue